import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { insertIf } from '@backmarket/utils/collection/insertIf'
import { isBrowser } from '@backmarket/utils/env/isBrowser'

import type {
  LinkBooster,
  LinkBoosterListType,
} from '~/api/internal-links/types'

export function useLinkBooster() {
  const $httpFetch = useHttpFetch()

  function fetchLinkBoosters({
    sourceUrl,
    listType,
    timeout,
  }: {
    sourceUrl: string
    listType: LinkBoosterListType
    timeout?: number
  }): Promise<LinkBooster[]> {
    return $httpFetch('/internal-links/v1/link-boosters', {
      query: {
        source_url: sourceUrl,
      },
      ...insertIf(!isBrowser() && timeout !== undefined, { timeout }),
    }).then(
      (data) =>
        data.linkLists
          .find((list) => list.listId === listType)
          ?.links.map(({ link, title }) => ({
            title,
            relativeLink: link.relativeHref,
          })) || [],
    )
  }

  return { fetchLinkBoosters }
}
